import React from 'react'
import PropTypes from 'prop-types'
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
// import { createStructuredSelector } from 'reselect'
import _ from 'lodash'
import shortid from 'shortid'
import classnames from 'classnames'
import moment from '../../lib/moment.js'
import styled from 'styled-components'
import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'

import { status } from '../../constants'

const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

class DivisionForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Division Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ _.get(this.props, 'confirm') === 'divisionForm' ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Form>
                  <FormGroup>
                    <ContainerInTab>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Start Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="start_date"
                            type="date"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            value={ moment(_.get(this.props, 'start_date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Division ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="division_code"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Division Code"
                            value={ _.get(this.props, 'division_code') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Division Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="division"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Division Name"
                            value={ _.get(this.props, 'division') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <FormGroup>
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }>
                            <Label>Department</Label>
                          </Col>
                          {
                            _.get(this.props, 'list.length') !== 0 &&
                            _.get(this.props, 'list.length') !== undefined &&
                            <Col sm={ 9 }>
                              <CustomInputField type="select" id="department_id" name="department_id" disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined } value={ _.get(this.props, 'department_id') } onChange={ this.props.handleInput }>
                                {
                                  _.get(this.props, 'list').map((department) => <option key={ shortid() } value={ department._id }>{ department.name }</option>)
                                }
                              </CustomInputField>
                            </Col>
                          }
                        </Row>
                        {
                          _.get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Status</Label></Col>
                            <Col sm={ 9 }>
                              <CustomInputField
                                type="select"
                                id="is_active"
                                name="is_active"
                                disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                                value={ this.props.is_active }
                                onChange={ this.props.handleInput }
                              >
                                {
                                  status.map((s, key) => <option key={ key } value={ s.value }>{ s.label }</option>)
                                }
                              </CustomInputField>
                            </Col>
                          </Row>
                        }
                      </FormGroup>
                    </ContainerInTab>
                  </FormGroup>
                  <Right>
                    { _.get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

DivisionForm.propTypes = {
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
  handleInput: PropTypes.func.isRequired,
}

export default DivisionForm

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`

const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`

const Image = styled.img`
width: 20px;
height: 20px;
position: absolute;
right: 10px;
`
const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const ContainerInTab = styled(Container)`
    /* overflow-y: scroll;
    max-height: calc(100vh - 220px); */
`

const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const InputFieldDate = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    float: right;
    ::-webkit-inner-spin-button {
      display: none;
      -webkit-appearance: none;
    }

`



// WEBPACK FOOTER //
// ./src/components/division/index.js